/**
 * AUTO-GENERATED — do not edit by hand.
 *
 * Maps Salesforce text-field API names to their max length, sourced from the
 * backend object metadata. Generated by scripts/generateFieldMaxLengths.mjs.
 * Re-run that script and commit the result when a field length changes in
 * Salesforce. See docs/field-length-enforcement.md.
 *
 * Used to set the `maxLength` attribute on text inputs and a Yup `.max()`
 * safety net so users cannot submit values that exceed the Salesforce column
 * length (MARCC-690).
 */
export const FIELD_MAX_LENGTHS: Record<string, number> = {
  Acute_Care_Facility_Name__c: 255,
  Additional_Details__c: 255,
  Additional_Findings__c: 3000,
  Administrator_Name_Text__c: 255,
  BMI__c: 10,
  Background_Information__c: 20000,
  Bed_Actual__c: 20,
  Bed_Description__c: 5000,
  Bed_Id__c: 255,
  Bed_Modification_Describe__c: 5000,
  Bed_at_Time_of_Incident__c: 50,
  Behaviour_Modification_Describe__c: 5000,
  Blood_Pressure_B__c: 255,
  Blood_Pressure_N_A_Rationale__c: 255,
  Blood_Pressure__c: 18,
  Call_Bell_Describe__c: 5000,
  Care_Plan__c: 32768,
  Care_Prior_to_Incident_Describe__c: 3000,
  CNA_at_Time_of_Incident_Text__c: 255,
  Caregiver_at_Time_of_Incident_Text__c: 255,
  Chair_Modification_Describe__c: 5000,
  Choking_Eating_Aids_Other__c: 255,
  Choking_Occurred_During_Other_Details__c: 255,
  Cognition_After_Incident_NA_Rationale__c: 5000,
  Cognition_Prior_to_Incident_NA_Rationale__c: 5000,
  Comments_from_Facility__c: 3000,
  Conclusion__c: 3000,
  Contributing_Causes_Other_Describe__c: 3000,
  Current_Weight__c: 100,
  DON_Name_Text__c: 255,
  Debridement_Frequency__c: 255,
  Describe_Ambulation_Status__c: 255,
  Describe_Behavior_Exhibited__c: 255,
  Describe_Chair__c: 5000,
  Describe_Changes_Upon_Assessment__c: 5000,
  Describe_Changes__c: 3000,
  Describe_Contributing_Causes__c: 255,
  Describe_Debridement__c: 255,
  Describe_Environmental_Impact__c: 255,
  Describe_Equipment_Malfunction__c: 255,
  Describe_Event__c: 255,
  Describe_Food_and_Consistency__c: 255,
  Describe_Furniture_Arrangement__c: 255,
  Describe_Initial_source_of_allegation__c: 255,
  Describe_Items_within_reach__c: 5000,
  Describe_Property_Damage__c: 255,
  Describe_Recevied_via__c: 255,
  Describe_Resident_Choked_on__c: 255,
  Describe_Resident_Code_Status__c: 255,
  Describe_Resident_Status__c: 255,
  Describe_Schedule__c: 255,
  Describe_Skin_Issues__c: 255,
  Describe_Type_of_allegation__c: 255,
  Describe_Wound_Base__c: 255,
  Describe_care_provided_prior_to_incident__c: 131072,
  Describe_fall_caused_by_resident_intent__c: 255,
  Describe_if_Resident_was_transferred__c: 255,
  Describe_incident__c: 5000,
  Describe_other_increased_supervision__c: 5000,
  Describe_other_lifts__c: 5000,
  Describe_received_medication__c: 5000,
  Describe_the_impact_of_Flooring_on_fall__c: 5000,
  Describe_the_impact_of_lighting_on_fall__c: 5000,
  Describe_the_impact_of_the_other_on_fall__c: 5000,
  Describe_toilet_details__c: 131072,
  Describe_transfer_type__c: 131072,
  Describe_visual_observation__c: 131072,
  Describe_why_Resident_was_transferred__c: 255,
  Description__c: 10000,
  Description_of_Event__c: 20000,
  Details_Last_Transfer_Prior_to_Injury__c: 255,
  Details__c: 255,
  Details_if_Immediate_Action_Was_Other__c: 5000,
  Details_of_Who_found_Resident__c: 255,
  Diagnoses_Included__c: 5000,
  Diet_Modifications_Describe__c: 3000,
  Dose__c: 255,
  Drainage_Type_Other_Describe__c: 255,
  Dressing_Frequency__c: 255,
  Dressing_Orders_Other_Description__c: 5000,
  Education_Caregiver__c: 3000,
  Education_Family_Representative__c: 3000,
  Education_Other__c: 3000,
  Education_Resident__c: 3000,
  Education_Staff__c: 3000,
  Education_Witness__c: 3000,
  Equipment_Modifications_Describe__c: 3000,
  Explain_timeline_of_events__c: 5000,
  Explain_why_physician_was_not_notified__c: 5000,
  Explain_why_resident_rep_not_notified__c: 255,
  External_Id__c: 255,
  Facility_Id__c: 255,
  Fall_Caused_by_Res_Behavior_Describe__c: 255,
  Family_or_Others__c: 255,
  Family_or_Visitor_Name__c: 255,
  Finger_Stick__c: 200,
  First_Aid__c: 3000,
  Floor_Actual__c: 20,
  Floor_Description__c: 32768,
  Floor_Id__c: 255,
  Floor_at_Time_of_Incident__c: 20,
  Foot_Care_Description__c: 3000,
  Frequency__c: 255,
  Full_Name__c: 255,
  Given_foodfluids_by_Name_Text__c: 255,
  Given_medication_by_Name_Text__c: 255,
  History_of_Fall_Incident_Description__c: 3000,
  Incident_Names__c: 25,
  Incident_Number__c: 50,
  Interviewee_Name_Text__c: 255,
  Interviewee_Statement__c: 32768,
  Interviewee_s_Name_Text__c: 255,
  Interviewer_Name_Text__c: 255,
  Interviewer_s_Name_Text__c: 255,
  Investigation__c: 13500,
  Labs_Culture_Text__c: 3000,
  Last_Four_digits_of_SSN__c: 4,
  Last_Skin_Check_Description__c: 3000,
  Last_T_P_Describe__c: 3000,
  List_Caregivers_Present__c: 3000,
  Mattress_Type_Other_Describe__c: 255,
  Medication_Dose_Administered__c: 255,
  Medication_Dose_Ordered__c: 255,
  Medication_Effect_on_Resident__c: 5000,
  Medication_NA_Reason__c: 2000,
  Medication_Name_Administered__c: 255,
  Medication_Name_Ordered__c: 255,
  Medication_Route_Administered__c: 255,
  Medication_Route_Ordered__c: 255,
  Medication_Schedule_Administered__c: 255,
  Medication_Schedule_Ordered__c: 255,
  Medication_Treatment_Per_MD__c: 3000,
  Medication_Type_of_Incident_Other__c: 3000,
  Medication_name__c: 255,
  Mitig8_Notes__c: 50000,
  Most_Recent_Comment__c: 5000,
  Name_Resident_Who_detected_incident__c: 255,
  Name_Who_detected_incident__c: 255,
  Name_of_Agency__c: 255,
  Nurse_Name_Text__c: 255,
  Nurse_Statement__c: 5000,
  Nurse_at_Time_of_Incident_Text__c: 255,
  O2_Saturation__c: 64,
  Offloading_Device_Type_Description__c: 3000,
  Org_UU_Id__c: 255,
  Other_Pertinent_History__c: 3000,
  Other_Preventative_Measures__c: 5000,
  Other_Wound_Info__c: 5000,
  Other_who_found_Resident__c: 255,
  Out_of_Facility_48_Hours_Description__c: 3000,
  Outcome__c: 13500,
  Pain_Details_And_Management__c: 3000,
  Patient_Overview__c: 32768,
  Physician_Name_Text__c: 255,
  Place_of_Incident_if_not_listed__c: 255,
  Position_Location_of_Resident_When_found__c: 5000,
  Position_of_Resident__c: 255,
  Previous_Incident_Status__c: 100,
  Prior_Incident_Risk_Rating__c: 255,
  Prior_Mitigate_History__c: 5000,
  Problem_Statement__c: 255,
  Progress_Notes_and_Assessments__c: 50000,
  Property_Damage_Additional_Details__c: 5000,
  Pulse_N_A_Rationale__c: 255,
  Pulse__c: 64,
  RELATED_LIST_Perpetrators__c: 25,
  Radiology_Text__c: 3000,
  Recent_Diet_Change_Describe__c: 3000,
  Recent_Infection_Describe__c: 3000,
  References__c: 255,
  Referrals_Description__c: 3000,
  Related_Incidents__c: 5000,
  Repositioned_by_Name_Text__c: 255,
  Resident_Action_ToI_Description__c: 255,
  Resident_Facility_Name__c: 255,
  Resident_Name_Text__c: 255,
  Resident_Representative_Name__c: 255,
  Resident_Statement__c: 5000,
  Respiration_NA_Rationale__c: 5000,
  Respiration__c: 64,
  Risk_Score__c: 2,
  Room_Actual__c: 20,
  Room_Description__c: 5000,
  Room_Id__c: 255,
  Room_at_Time_of_Incident__c: 50,
  Root_Causes__c: 255,
  Route_Notes__c: 32768,
  Shift_Worked__c: 255,
  Signatures_Completed_By__c: 255,
  Skin_Issue_Type_Other__c: 255,
  Staff_Member_Responsible_Name__c: 255,
  Staff_Name_Staff_who_lowered_to_ground__c: 255,
  Staff_Name_Text__c: 255,
  Summary_of_Findings__c: 32768,
  Supervisor_Name_Text__c: 255,
  Supervisor_Statement_Name_Text__c: 255,
  Supervisor_Statement__c: 5000,
  T_P_Schedule_Describe__c: 3000,
  Temperature__c: 200,
  Therapist_Name__c: 255,
  Toileted_Prior_to_Incident_Describe__c: 3000,
  Toileted_by_Name_Text__c: 255,
  Transfer_Other__c: 3000,
  Transfer_Type_Other_Describe__c: 3000,
  Transferred_by_Name_Text__c: 255,
  Unit_Actual__c: 20,
  Unit_Assignment__c: 255,
  Unit_Description__c: 32000,
  Unit_Id__c: 255,
  Unit_Manager_Supervisor_Name__c: 255,
  Unit_at_Time_of_Incident__c: 50,
  Visitor_Name__c: 18,
  Visitor_Other_Who_Last_Saw_Resident__c: 255,
  Visitor_who_found_Resident__c: 255,
  Visually_Observed_Description__c: 255,
  Visually_observed_by_Name_Text__c: 255,
  What_Was_Resident_Doing_at_That_Time__c: 255,
  What_equipment_was_involved__c: 255,
  Where_Was_Resident_Last_Seen__c: 255,
  Where_Was_Resident_Located__c: 255,
  Which_Medications__c: 255,
  Why_1__c: 255,
  Why_2__c: 255,
  Why_3__c: 255,
  Why_4__c: 255,
  Why_5__c: 255,
  Why_was_Admin_not_notified__c: 5000,
  Witness_Name_Text__c: 255,
  Witness_Name__c: 100,
  Witness_Statement__c: 5000,
  Wound_Description_Other__c: 3000,
  Wound_Description__c: 255,
  Wound_Dimensions__c: 255,
  Wound_Location__c: 25,
  Wound_Size_D__c: 255,
  Wound_Size_L__c: 255,
  Wound_Size_W__c: 255,
  Wound_Size__c: 255,
};

/** Returns the Salesforce max length for a field, or undefined if uncapped. */
export const getFieldMaxLength = (fieldName?: string): number | undefined =>
  fieldName ? FIELD_MAX_LENGTHS[fieldName] : undefined;
